import { fetchClient } from '../../../config/api';

/**
 * Fetch all domains from the backend
 */
export const fetchDomains = async () => {
  const response = await fetchClient('/domains', {
    method: 'GET',
    cache: 'no-store'
  });
  return await response.json();
};

/**
 * Update the domains list on the backend
 */
export const updateDomains = async (domains) => {
  const response = await fetchClient('/domains', {
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify(domains)
  });
  return await response.json();
};

/**
 * Fetch exchange rate from Banxico (public API proxy if needed, or directly)
 */
export const fetchExchangeRateBanxico = async () => {
  const response = await fetchClient('/exchange-rate', {
    method: 'GET',
    cache: 'no-store'
  });
  return await response.json();
};
